'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileError = exports.cancelReservation = exports.deleteStudioBookmark = exports.createStudioBookmark = exports.loadUpcomingReservations = exports.loadSidebarData = exports.loadPastReservations = exports.loadStudioBookmarks = exports.CANCEL_RESERVATION = exports.DELETE_STUDIO_BOOKMARK = exports.CREATE_STUDIO_BOOKMARK = exports.LOAD_UPCOMING_RESERVATIONS = exports.LOAD_SIDEBAR_DATA = exports.LOAD_PAST_RESERVATIONS = exports.LOAD_STUDIO_BOOKMARKS = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.bookmarkRequest = bookmarkRequest;
exports.unbookmarkRequest = unbookmarkRequest;
exports.doLoadStudioBookmarks = doLoadStudioBookmarks;
exports.doLoadPastReservations = doLoadPastReservations;
exports.doLoadSidebarData = doLoadSidebarData;
exports.doLoadUpcomingReservations = doLoadUpcomingReservations;
exports.trackFavorite = trackFavorite;
exports.doCreateStudioBookmark = doCreateStudioBookmark;
exports.doDeleteStudioBookmark = doDeleteStudioBookmark;
exports.doCancelReservation = doCancelReservation;
exports.watchLoadStudioBookmarks = watchLoadStudioBookmarks;
exports.watchLoadPastReservations = watchLoadPastReservations;
exports.watchLoadSidebarData = watchLoadSidebarData;
exports.watchLoadUpcomingReservations = watchLoadUpcomingReservations;
exports.watchCreateStudioBookmark = watchCreateStudioBookmark;
exports.watchDeleteStudioBookmark = watchDeleteStudioBookmark;
exports.watchCancelReservation = watchCancelReservation;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _multitrack = require('helpers/multitrack');

var _searchInstanceId = require('helpers/searchInstanceId');

var _searchInstanceId2 = _interopRequireDefault(_searchInstanceId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(bookmarkRequest),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(unbookmarkRequest),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadStudioBookmarks),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadPastReservations),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doLoadSidebarData),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(doLoadUpcomingReservations),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(trackFavorite),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(doCreateStudioBookmark),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(doDeleteStudioBookmark),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(doCancelReservation),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(watchLoadStudioBookmarks),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(watchLoadPastReservations),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(watchLoadSidebarData),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(watchLoadUpcomingReservations),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(watchCreateStudioBookmark),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(watchDeleteStudioBookmark),
    _marked17 = /*#__PURE__*/_regenerator2.default.mark(watchCancelReservation);

var LOAD_STUDIO_BOOKMARKS = exports.LOAD_STUDIO_BOOKMARKS = 'LOAD_STUDIO_BOOKMARKS';
var LOAD_PAST_RESERVATIONS = exports.LOAD_PAST_RESERVATIONS = 'LOAD_PAST_RESERVATIONS';
var LOAD_SIDEBAR_DATA = exports.LOAD_SIDEBAR_DATA = 'LOAD_SIDEBAR_DATA';
var LOAD_UPCOMING_RESERVATIONS = exports.LOAD_UPCOMING_RESERVATIONS = 'LOAD_UPCOMING_RESERVATIONS';
var CREATE_STUDIO_BOOKMARK = exports.CREATE_STUDIO_BOOKMARK = 'CREATE_STUDIO_BOOKMARK';
var DELETE_STUDIO_BOOKMARK = exports.DELETE_STUDIO_BOOKMARK = 'DELETE_STUDIO_BOOKMARK';
var CANCEL_RESERVATION = exports.CANCEL_RESERVATION = 'CANCEL_RESERVATION';

var loadStudioBookmarks = exports.loadStudioBookmarks = function loadStudioBookmarks(userId) {
  return { type: LOAD_STUDIO_BOOKMARKS, userId: userId };
};
var loadPastReservations = exports.loadPastReservations = function loadPastReservations() {
  return { type: LOAD_PAST_RESERVATIONS };
};
var loadSidebarData = exports.loadSidebarData = function loadSidebarData(userId) {
  return { type: LOAD_SIDEBAR_DATA, userId: userId };
};
var loadUpcomingReservations = exports.loadUpcomingReservations = function loadUpcomingReservations(userId) {
  return { type: LOAD_UPCOMING_RESERVATIONS, userId: userId };
};
var createStudioBookmark = exports.createStudioBookmark = function createStudioBookmark(userId, studioId, studioType) {
  return {
    type: CREATE_STUDIO_BOOKMARK, userId: userId, studioId: studioId, studioType: studioType
  };
};
var deleteStudioBookmark = exports.deleteStudioBookmark = function deleteStudioBookmark(userId, studioId) {
  return { type: DELETE_STUDIO_BOOKMARK, userId: userId, studioId: studioId };
};
var cancelReservation = exports.cancelReservation = function cancelReservation(userId, reservationId) {
  return { type: CANCEL_RESERVATION, userId: userId, reservationId: reservationId };
};
var profileError = exports.profileError = _helpers.errorActionCreator.bind(null, 'PROFILE_ERROR');

function bookmarkRequest(client, userId, payload) {
  return _regenerator2.default.wrap(function bookmarkRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client.users.addBookmark(userId, payload);

        case 2:
          return _context.abrupt('return', _context.sent);

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function unbookmarkRequest(client, userId, studioId) {
  return _regenerator2.default.wrap(function unbookmarkRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return client.users.deleteBookmark(userId, studioId);

        case 2:
          return _context2.abrupt('return', _context2.sent);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doLoadStudioBookmarks(client, _ref) {
  var userId = _ref.userId;
  return _regenerator2.default.wrap(function doLoadStudioBookmarks$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.studioBookmarks, [client, userId]);

        case 3:
          _context3.next = 9;
          break;

        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 9;
          return (0, _effects.put)(profileError(_context3.t0));

        case 9:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 5]]);
}

function doLoadPastReservations(client) {
  return _regenerator2.default.wrap(function doLoadPastReservations$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.achievementsPastReservations, [client]);

        case 3:
          _context4.next = 11;
          break;

        case 5:
          _context4.prev = 5;
          _context4.t0 = _context4['catch'](0);

          if (!(_context4.t0.path === '/v1/achievements/past_reservations')) {
            _context4.next = 9;
            break;
          }

          return _context4.abrupt('return');

        case 9:
          _context4.next = 11;
          return (0, _effects.put)(profileError(_context4.t0));

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 5]]);
}

function doLoadSidebarData(client, _ref2) {
  var userId = _ref2.userId;
  var permissions;
  return _regenerator2.default.wrap(function doLoadSidebarData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, userId]);

        case 3:
          permissions = _context5.sent;

          if (!permissions.feature_videos) {
            _context5.next = 7;
            break;
          }

          _context5.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.videoBookmarks, [client, userId]);

        case 7:
          _context5.next = 9;
          return (0, _effects.all)([
          // call(fetchEntity, userPastReservationsCount, [client, userId]),
          (0, _effects.call)(_sagaTools.fetchEntity, _bound.achievementsPastReservationsCount, [client]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.studioBookmarks, [client, userId]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.userCreditBalance, [client, userId]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.subscription, [client, userId])]);

        case 9:
          _context5.next = 17;
          break;

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5['catch'](0);

          if (!(_context5.t0.path === '/v1/achievements/past_reservations_meta')) {
            _context5.next = 15;
            break;
          }

          return _context5.abrupt('return');

        case 15:
          _context5.next = 17;
          return (0, _effects.put)(profileError(_context5.t0));

        case 17:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 11]]);
}

function doLoadUpcomingReservations(client) {
  var user;
  return _regenerator2.default.wrap(function doLoadUpcomingReservations$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 3:
          user = _context6.sent;
          _context6.next = 6;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.userUpcomingReservations, [client, user.id]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.studioBookmarks, [client, user.id])]);

        case 6:
          _context6.next = 12;
          break;

        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 12;
          return (0, _effects.put)(profileError(_context6.t0));

        case 12:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[0, 8]]);
}

function trackFavorite(userId, studioId, action) {
  var _ref3, _ref4, searchInstanceId, userCookies;

  return _regenerator2.default.wrap(function trackFavorite$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.all)([(0, _effects.call)(_searchInstanceId2.default), (0, _effects.call)(_cookie2.default.parse, document.cookie)]);

        case 2:
          _ref3 = _context7.sent;
          _ref4 = (0, _slicedToArray3.default)(_ref3, 2);
          searchInstanceId = _ref4[0];
          userCookies = _ref4[1];
          _context7.next = 8;
          return (0, _effects.call)(_multitrack.ec, 'Favorite', {
            action: action,
            search_id: searchInstanceId,
            venue_id: studioId,
            url: window.location.pathname + window.location.search,
            user_id: userId,
            app_platform: 'web',
            session_id: userCookies._gid // eslint-disable-line no-underscore-dangle
          });

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function doCreateStudioBookmark(client, _ref5) {
  var userId = _ref5.userId,
      studioId = _ref5.studioId,
      studioType = _ref5.studioType;
  return _regenerator2.default.wrap(function doCreateStudioBookmark$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(bookmarkRequest, client, userId, { ref_id: studioId, type: studioType });

        case 3:
          _context8.next = 5;
          return (0, _effects.fork)(doLoadStudioBookmarks, client, { userId: userId });

        case 5:
          if (!(studioType === 'venue')) {
            _context8.next = 8;
            break;
          }

          _context8.next = 8;
          return (0, _effects.call)(trackFavorite, userId, studioId, 'favorite');

        case 8:
          _context8.next = 14;
          break;

        case 10:
          _context8.prev = 10;
          _context8.t0 = _context8['catch'](0);
          _context8.next = 14;
          return (0, _effects.put)(profileError(_context8.t0));

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[0, 10]]);
}

function doDeleteStudioBookmark(client, _ref6) {
  var userId = _ref6.userId,
      studioId = _ref6.studioId;
  var bookmarks, studio, bookmarkId;
  return _regenerator2.default.wrap(function doDeleteStudioBookmark$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.studioBookmarks, [client, userId]);

        case 3:
          bookmarks = _context9.sent;
          studio = bookmarks.filter(function (s) {
            return s[s.type].id === studioId;
          })[0];

          if (studio) {
            _context9.next = 7;
            break;
          }

          return _context9.abrupt('return');

        case 7:
          bookmarkId = studio[studio.type].bookmark_id;
          _context9.next = 10;
          return (0, _effects.call)(unbookmarkRequest, client, userId, bookmarkId);

        case 10:
          _context9.next = 12;
          return (0, _effects.fork)(doLoadStudioBookmarks, client, { userId: userId });

        case 12:
          if (!(studio.type === 'venue')) {
            _context9.next = 15;
            break;
          }

          _context9.next = 15;
          return (0, _effects.call)(trackFavorite, userId, studioId, 'unfavorite');

        case 15:
          _context9.next = 21;
          break;

        case 17:
          _context9.prev = 17;
          _context9.t0 = _context9['catch'](0);
          _context9.next = 21;
          return (0, _effects.put)(profileError(_context9.t0));

        case 21:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this, [[0, 17]]);
}

function doCancelReservation(client, _ref7) {
  var userId = _ref7.userId,
      reservationId = _ref7.reservationId;
  return _regenerator2.default.wrap(function doCancelReservation$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.cancelReservationEntity, [client, userId, reservationId, { state: 'cancel' }]);

        case 2:
          _context10.next = 4;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.userUpcomingReservations, [client, userId]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.userProfile, [client, userId]), (0, _effects.call)(_sagaTools.fetchEntity, _bound.userCreditBalance, [client, userId])]);

        case 4:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function watchLoadStudioBookmarks(client) {
  return _regenerator2.default.wrap(function watchLoadStudioBookmarks$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_STUDIO_BOOKMARKS, doLoadStudioBookmarks, client);

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function watchLoadPastReservations(client) {
  return _regenerator2.default.wrap(function watchLoadPastReservations$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_PAST_RESERVATIONS, doLoadPastReservations, client);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function watchLoadSidebarData(client) {
  return _regenerator2.default.wrap(function watchLoadSidebarData$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_SIDEBAR_DATA, doLoadSidebarData, client);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function watchLoadUpcomingReservations(client) {
  return _regenerator2.default.wrap(function watchLoadUpcomingReservations$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_UPCOMING_RESERVATIONS, doLoadUpcomingReservations, client);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function watchCreateStudioBookmark(client) {
  return _regenerator2.default.wrap(function watchCreateStudioBookmark$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, CREATE_STUDIO_BOOKMARK, doCreateStudioBookmark, client);

        case 2:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function watchDeleteStudioBookmark(client) {
  return _regenerator2.default.wrap(function watchDeleteStudioBookmark$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, DELETE_STUDIO_BOOKMARK, doDeleteStudioBookmark, client);

        case 2:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function watchCancelReservation(client) {
  return _regenerator2.default.wrap(function watchCancelReservation$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, CANCEL_RESERVATION, doCancelReservation, client);

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}